import Vue from 'vue';
import apiClient from '@/apiClient';

const state = {
  info: {
    id: '',
    name: '',
    email: '',
    country: '',
    country_id: '',
    region: '',
    region_id: '',
    city: '',
    city_id: '',
    address: '',
    contact_person: '',
    contact_phone: '',
    contact_email: '',
    website: '',
    tariff_id: '',
    due_payment_date: '',
    status: ''
  },
  orderStatuses: []
};

const actions = {
  firmInfo: ({ commit }, firmId) =>
    new Promise((resolve, reject) => {
      apiClient
        .get(`/firms/${firmId}`)
        .then(resp => {
          commit('firmData', resp.data);
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    }),

  updateFirmInfo: ({ commit, dispatch }, { firmId, firmData }) =>
    new Promise((resolve, reject) => {
      apiClient
        .put(`/firms/${firmId}`, firmData)
        .then(response => {
          dispatch('userRequest');
          commit('firmData', response.data);

          resolve(response);
        })
        .catch(error => {
          // bad news. Return error. Do not commit data to store
          reject(error);
        });
    })
};

const mutations = {
  firmData: (state, firmData) => {
    Vue.set(state, 'info', firmData);
  }
};

export default {
  state,
  actions,
  mutations
};
